<template>
  <div class="clientes">
    <div class="d-flex justify-content-between">
      <div class="input-group mb-3">
        <button v-on:click="adicionarHandle()" class="btn btn-success">
          <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
        </button>
      </div>

      <div class="input-group mb-3">
        <input
            v-on:keyup.enter="handlePesquisa()"
            type="text"
            class="form-control"
            placeholder="Pesquisar"
            aria-label="Pesquisar"
            aria-describedby="button-addon2">
        <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
          <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
        </button>
      </div>
    </div>
    <div class="d-flex">
      <table class="table table-sm-pc table-striped table-hover">
        <thead>
          <tr>
            <th width="25">#</th>
            <th>Identificação</th>
            <th width="85">Prioridade</th>
            <th width="75"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="grupo in listaGrupos" :key="grupo.id">
              <td scope="row">{{grupo.id}}</td>
              <td>{{grupo.descricao}}</td>
              <td>{{grupo.prioridade}}</td>
              <td class="text-end">
                <button type="button" v-on:click="editaGrupoHandle(grupo)" class="btn btn-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                </button>
                <button type="button" v-on:click="removeGrupoHandle(grupo)" class="btn btn-danger btn-sm">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </td>

            </tr>
          </tbody>
      </table>
    </div>
    <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

    <!-- modal-edita-grupo -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-grupo" id="btn-modal-edita-grupo-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-grupo" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalGrupo.form.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Cadastrar novo Plano de Acesso
            </h5>
            <h5 v-if="!!modalGrupo.form.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando Plano de Acesso
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-9 col-md-10">
                <label class="required">Identificação</label>
                <input type="text" v-model="modalGrupo.form.descricao" class="form-control" placeholder="Nome do grupo">
              </div>
              <div class="col-12 col-sm-3 col-md-2">
                <label class="required">Prioridade</label>
                <input type="number" v-model.number="modalGrupo.form.prioridade" min="0" max="255" class="form-control" placeholder="">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-grupo-fecha">Fechar</button>
            <button type="button"
                v-if="!modalGrupo.form.id"
                v-on:click="handleModalGrupoCadastrar()"
                v-bind:disabled="!podeSalvarGrupo()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalGrupo.form.id"
                v-on:click="handleModalGrupoSalvar()"
                v-bind:disabled="!podeSalvarGrupo()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-grupo -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ConfigHelpdeskGrupos',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaGrupos: [],
      modalGrupo: {
        form: {
          id: undefined,
          descricao: '',
          prioridade: 0,
        },
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/helpdesk/grupos?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaGrupos = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    adicionarHandle() {
      this.resetmodalGrupo();
      this.abreModalCadastroGrupo();
    },

    async editaGrupoHandle(grupo) {
      this.resetmodalGrupo();

      this.modalGrupo.form = clone(grupo);

      this.abreModalCadastroGrupo();
    },

    removeGrupoHandle(grupo) {
      dialogo.confirmacao(`Confirma remover o Plano de Acesso <b>${grupo.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/helpdesk/grupos/${grupo.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroGrupo() {
      document.getElementById('btn-modal-edita-grupo-abre').click();
    },

    resetmodalGrupo() {
      this.modalGrupo.form.id = undefined;
      this.modalGrupo.form.descricao = '';
      this.modalGrupo.form.prioridade = 0;
    },

    podeSalvarGrupo() {
      switch (true) {
        case (this.modalGrupo.form.descricao.length < 3):
        case (this.modalGrupo.form.prioridade <= 0):
          return false;

        default:
          return true;
      }
    },

    handleModalGrupoCadastrar() {
      const sendData = {
        id: undefined,
        descricao: this.modalGrupo.form.descricao,
        prioridade: this.modalGrupo.form.prioridade,
      };

      loading(true);

      api.post('/helpdesk/grupos', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-grupo-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalGrupoSalvar() {
      const sendData = {
        id: this.modalGrupo.form.id,
        descricao: this.modalGrupo.form.descricao,
        prioridade: this.modalGrupo.form.prioridade,
      };

      loading(true);
      api.put(`/helpdesk/grupos/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-grupo-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },

  created() {
    this.handlePesquisa();
  }
}
</script>
